import { Link } from "react-router-dom";
import { CheckIcon } from "../pricing/constants";
import { why_constants } from "./constants";

export default function Why() {
  return (
    <section className="py-10 bg-white">
      <div className="container  px-3">
        <div className="grid sm:grid-cols-2 gap-7">
          <div className={`space-y-[18px]`}>
            <h3 className="text-[20px] lg:text-[32px] font-bold text-black ">
              Fine-tuning Specializations
            </h3>

            <div className="space-y-3">
              {why_constants.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckIcon />
                  <span className="text-[#222] text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <Link
              to="/signup"
              className="rounded-lg bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white text-center hover:text-white/80 w-max inline-block"
            >
              Find Your Specialization
            </Link>
          </div>

          <div className="rounded-[12px]">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755251224/powerdbyai/fine-tunning_qtlswf.png"
              alt="specialization"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
